import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface TuneSettingsCSSStyle extends CRBTUICSSStyle
{
    getInnerWrapperCSSStyle():object;
    getHeaderContentDivCSSStyle():object;
    getTuneImageDivCSSStyle():object;
    getTuneDetailsDivCSSStyle():object;
    getTuneNameLabelCSSStyle():object;
    getArtistNameLabelCSSStyle():object;
    getCloseButtonCSSStyle():object;
    getSettingWrapperDivCSSStyle():object;
    getAdvanceSettingLabelCSSStyle():object;
    getAdvanceTimeContentLabelCSSStyle(): object;
    getAdvanceContentLabelCSSStyle():object;
    getChooseDateTimeDivCSSStyle():object;
    getConfirmButtonDivCSSStyle():object;
}
 export class TuneSettingsCSSStyleImpl  extends CRBTUICSSStyleImpl implements TuneSettingsCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'100%', 
            // display:'flex', 
            paddingBottom: "30px", 
            // borderRadius:'8px', 
            backgroundColor:'#FFFFFF'
        };
    }

    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%', height:'100%',display:'flex',flexDirection: "row",flexFlow: "row wrap",position:"relative"
        };
    }

    getHeaderContentDivCSSStyle():object
    {
        return{
            width:'100%', 
            height:'120px',
            backgroundColor:'#FAFAFB', 
            display:'flex',
            borderRadius:'8px 8px 0px  0px',
        };
    }

    getTuneImageDivCSSStyle():object
    {
        return{
            border:'8px 0px 0px 0px', 
            display:'inline-block'
        };
    }

    getTuneDetailsDivCSSStyle():object
    {
        return{
            display:'inline-block', width:'100%', height:'60px'
        };
    }

    getTuneNameLabelCSSStyle():object
    {
        return{
            width:'100%', 
            height:'30px', 
            lineHeight:'30px',
            color:'#1B1919', 
            fontFamily: this.getResources().getFontFamily(),
            fontSize:'18px', 
            fontWeight:"bold",
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getArtistNameLabelCSSStyle():object
    {
        return{
            width:'100%',
            minWidth:'150px',
            height:'20px', 
            lineHeight:'20px', 
            fontSize:'16px', 
            fontFamily: this.getResources().getFontFamily(),
            color:'#B6B6B6', 
            fontWeight:300,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getCloseButtonCSSStyle():object
    {
        return{
            width:'16px', 
            height:'16px',
            cursor:"pointer", 
            marginRight:'21px', 
            marginTop:'22px'
        };
    }

    getSettingWrapperDivCSSStyle():object
    {
        return{
            width:'100%', height:'auto', display:'inline-block',
        };
    }

    getAdvanceSettingLabelCSSStyle():object{
        return{
            fontSize:'24px',
            height:'40px',
            width:'100%', 
            lineHeight:'40px',
            fontFamily: this.getResources().getFontFamily(),
            marginBottom:'11px', 
            letterSpacing:'0px',
            color:'#221E20', 
            fontWeight:500 
        };
    }

    getAdvanceContentLabelCSSStyle():object
    {
        return{
            width:'100%', 
            height:'25px',
            fontSize:'18px', 
            lineHeight:'25px',
            // textAlign:"left",
            fontFamily: this.getResources().getFontFamily(),
            color:'#221E20', 
            letterSpacing:'0',
            fontWeight:900
        };
    }

    getAdvanceTimeContentLabelCSSStyle():object
    {
        return{
            width:'100%', 
            height:'25px',
            fontSize:'18px', 
            // textAlign:"left",
            lineHeight:'25px',
            fontFamily: this.getResources().getFontFamily(),
            color:'#221E20', 
            letterSpacing:'0',
            fontWeight:900
        };
    }

    getChooseDateTimeDivCSSStyle():object
    {
        return{
            width:'100%',marginTop: "30px",fontFamily: this.getResources().getFontFamily(), height:'20px',fontSize:'15px', lineHeight:'20px',color:'#221E20', letterSpacing:'0'        };
    }

    getConfirmButtonDivCSSStyle():object
    {
        return{
            marginLeft:'0px', marginTop:'30px',display:'flex'
        };
    }
}   


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingscss.tsx